import type { ISpread } from "../../spreadsSlice";

export const psychologicalLifeProfileSpread: ISpread = {
  id: "spread_psychological_life_profile",
  name: "Психологический профиль жизненного пути",
  purpose:
    "Комплексный анализ жизненных этапов, сознательных и бессознательных процессов, отношений, ресурсов и зон уязвимости.",
  cardsCount: 12,
  layout: "[1][2][3][4][5][6][7][8][9][10][11][12]",
  positions: [
    {
      id: "early_childhood",
      title: "Раннее детство",
      meaning: "Влияния первых лет жизни.",
    },
    {
      id: "adolescence",
      title: "Подростковый возраст",
      meaning: "Становление идентичности.",
    },
    {
      id: "youth",
      title: "Молодость",
      meaning: "Начало самостоятельного пути.",
    },
    {
      id: "maturity",
      title: "Зрелость",
      meaning: "Текущее восприятие жизни.",
    },
    {
      id: "old_age",
      title: "Старость",
      meaning: "Мудрость и итог накопленного опыта.",
    },
    {
      id: "consciousness",
      title: "Сознание",
      meaning: "Мысли, убеждения и планы.",
    },
    {
      id: "unconscious",
      title: "Бессознательное",
      meaning: "Глубинные мотивы и страхи.",
    },
    {
      id: "relationships",
      title: "Взаимоотношения",
      meaning: "То, как строятся связи с другими людьми.",
    },
    {
      id: "strengths",
      title: "Сильные стороны",
      meaning: "Ресурсы и устойчивые качества.",
    },
    {
      id: "weaknesses",
      title: "Слабые стороны",
      meaning: "Зоны уязвимости и внутреннего напряжения.",
    },
    {
      id: "spirituality",
      title: "Духовность",
      meaning: "Связь с высшими смыслами.",
    },
    {
      id: "synthesis",
      title: "Общая картина",
      meaning: "Синтез основных тем психологического профиля.",
    },
  ],
  symbolism:
    "Соединяет временную линию жизненного пути с внутренними, социальными и духовными аспектами личности.",
  archetypes: ["Жизненный путь", "Развитие", "Интеграция"],
  psychology:
    "Помогает увидеть повторяющиеся паттерны, связь жизненного опыта с текущим состоянием, ресурсы и зоны дальнейшего роста.",
  procedure: {
    preparation:
      "Сформулировать намерение исследовать жизненный путь и текущую структуру личности.",
    steps:
      "Перетасовать колоду; выложить двенадцать карт по порядку; сначала рассмотреть жизненные этапы, затем внутренние процессы, отношения, ресурсы и итоговый синтез.",
  },
  interpretations: [
    "Повторяющиеся мотивы в разных возрастных периодах могут показывать устойчивый жизненный паттерн.",
    "Связь сознательной и бессознательной позиций помогает увидеть внутренние противоречия.",
  ],
  nuances: [
    "Это CUSTOM-расклад проекта, отдельный от SOURCE-расклада «Психологический круг».",
    "Общая картина является синтезом остальных позиций, а не отдельным прогнозом.",
  ],
  examples: [],
  selfQuestions: [
    "Какие темы повторяются на разных этапах моего пути?",
    "Какие внутренние ресурсы помогают мне развиваться?",
    "Какие противоречия требуют интеграции?",
  ],
};

